module.exports = __webpack_public_path__ + "img/hr-H-B-123456-load-standup-base.247d5cb1.png";